/** Created by azhou on 2018/11/30.*/
<template>
  <div class="echart-wrap">
    <p class="h4 text-link text-right w-100 pr-5 mb-3" @click="$emit('closeEchart')">切换表格模式</p>
    <div class="d-center pl-5 pr-5 w-100 mb-5">
      <div class="text-white w-100">
        <span class="ml-5">今日在线用户： {{currentData.today_active_count}}</span>
        <span class="ml-5">今日发布订单：{{currentData.send_order_nos}}</span>
        <span class="ml-5">今日成交订单：{{currentData.success_order_nos}}</span>
        <span class="ml-5">今日在线支付：{{currentData.pay_moneys/100 | formatMoney}}元</span>
        <span class="ml-5">今日成交金额：{{currentData.success_order_price | formatMoney}}元</span>
      </div>
      <div class="d-flex align-items-center w-15 mr-5">
        <el-date-picker v-model="startMonth"
                        type="month"
                        class="mr-2" size="small"
                        value-format="yyyy-MM"
                        placeholder="开始时间" />
        <el-date-picker v-model="endMonth"
                        type="month" size="small"
                        value-format="yyyy-MM"
                        placeholder="结束时间" />
      </div>
    </div>
    <div class="e-data">
      <!--echart地图-->
      <transition name="fade">
        <e-map v-show="!showDetailFlag" :dataSet="mapDataSet" />
      </transition>
      <!--采购商/酒店/民宿/总计数据-->
      <div :class="['p-3',dataItem.className]" v-for="dataItem in groupData" :key="dataItem.type">
        <p class="text-warning h4">{{dataItem.title}}</p>
        <div v-for="item in dataItem.childData" class="d-center-between mb-1" :key="item.name">
          {{item.name}}
          <span v-if="item.valueType==='money'"> {{item.value | formatMoney}}</span>
          <span v-else>{{item.value}}</span>
        </div>
        <div class="text-center" @click="showDataDetail(dataItem.type)">
          <span class="text-link">{{showDetail===dataItem.type ?'收起':'查看更多'}}</span>
        </div>
      </div>
      <transition name="fade">
        <div class="bar-wrap" v-if="showDetailFlag">
          <el-scrollbar style="height:100%;">
            <div class="text-white font-weight-bold text-center h4 mb-4">
              {{chartTitle}}
              <el-popover placement="bottom-end" width="300" trigger="hover" :content="tooltipText">
                <span slot="reference"><i class="el-icon-question h6 ml-2 text-warning"></i></span>
              </el-popover>
            </div>
            <e-bar :DataSet="BarDataSet_1" class="mt-5 mb-5" :xAxisSet="BarxAxisSet"></e-bar>
            <e-line :DataSet="LineDataSet" class="mt-5 mb-5" :xAxisSet="BarxAxisSet"></e-line>
            <e-pie :DataSet="PieDataSet_1" class="mt-5 mb-5" chartTitle="订单地区分类" mountId="e-pie-local"></e-pie>
            <e-pie :DataSet="PieDataSet_2" class="mt-5 mb-5" chartTitle="订单类型分类" mountId="e-pie-order"
                   v-if="showDetail==='2'||showDetail==='0'"></e-pie>
            <div class="position-relative">
              <e-pie :DataSet="PieDataSet_3" class="mt-5 mb-5" chartTitle="用户地区分类" mountId="e-pie-user"
                     @clickPie="getUserDis"></e-pie>
              <div class="city-list">
                <el-scrollbar style="height:100%;">
                  <div class="city-item-wrap">
                    <div class="d-center-between mb-1"
                         v-for="(cityItem,index) in disDataSet" :key="cityItem.title"
                         :class="{'mb-5':index===disDataSet.length-1}">
                      <span class="w-30 text-left">{{cityItem.title}}</span>
                      <span class="w-20 text-left">{{cityItem.value}}</span>
                      <span class="w-50 text-right">（{{cityItem.proportion}}）</span>
                    </div>
                  </div>
                </el-scrollbar>
              </div>
            </div>
            <e-bar :DataSet="BarDataSet_2" :xAxisSet="BarxAxisSet" chartTitle="用户信息数据统计" mountId="e-line-user"></e-bar>
          </el-scrollbar>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import EMap from './EMap'
  import EBar from './EBar'
  import EPie from './EPie'
  import ELine from './ELine'

  export default {
    data() {
      return {
        showDetail: '',                    //当前查看的哪一个身份的用户数据
        tooltipText:'2018年8月1日平台升级为2.0版本，在升级过程中，原1.0版本的数据库中订单存储的方式为单一存储，不适用新的订单存储方式，新订单改为一个订单可预订多家酒 店。所以把原数据库中统计的所有数值都保留在了2018年7月份中。致使7月份数据最高原因。',
        groupData: [
          {
            title: '采购商',
            type: '2',
            className: 'travel-data',
            childData: [
              {name: '认证数', key: 'reg_nums', value: 0, valueType: 'normal'},
              // {name: '发布订单数', key: 'send_order_nos', value: 0, valueType: 'normal'},
              // {name: '成交订单数', key: 'success_order_nos', value: 0, valueType: 'normal'},
              {name: '发布订单总额', key: 'send_order_price', value: 0, valueType: 'money'},
              {name: '成交订单总额', key: 'success_order_price', value: 0, valueType: 'money'},]
          },
          {
            title: '酒店',
            type: '3',
            className: 'hotel-data',
            childData: [
              {name: '认证数', key: 'reg_nums', value: 0, valueType: 'normal'},
              {name: '订单总数', key: 'order_nos', value: 0, valueType: 'normal'},
              {name: '成交订单数', key: 'success_order_nos', value: 0, valueType: 'normal'},
              {name: '成交订单总额', key: 'success_order_price', value: 0, valueType: 'money'},
              {name: '成交订单客单价', key: 'unit_price', value: 0, valueType: 'money'},]
          },
          {
            title: '民宿',
            type: '5',
            className: 'homestay-data',
            childData: [
              {name: '认证数', key: 'reg_nums', value: 0, valueType: 'normal'},
              {name: '订单总数', key: 'order_nos', value: 0, valueType: 'normal'},
              {name: '成交订单数', key: 'success_order_nos', value: 0, valueType: 'normal'},
              {name: '成交订单总额', key: 'success_order_price', value: 0, valueType: 'money'},
              {name: '成交订单客单价', key: 'unit_price', value: 0, valueType: 'money'},]
          },
          {
            title: '合计',
            type: '0',
            className: 'total-data',
            childData: [
              {name: '认证数', key: 'reg_nums', value: 0, valueType: 'normal'},
              {name: '认证总数', key: 'verify_nums', value: 0, valueType: 'normal'},
              {name: '发布订单总额', key: 'send_order_price', value: 0, valueType: 'money'},
              {name: '成交订单总额', key: 'success_order_price', value: 0, valueType: 'money'},
              {name: '在线支付订单总额', key: 'total_pay_price', value: 0, valueType: 'money'},]
          }
        ],
        BarxAxisSet: [],                   //横轴根据后台返回的年月的显示
        mapDataSet:[],                     //地图数据集合
        BarDataSet_1: [],                  //订单柱状图数据集合
        BarDataSet_2: [],                  //订单柱状图用户信息数据统计
        PieDataSet: [],                    //占比统计饼状图数据集合
        LineDataSet: [],                   //折线图数据集合
        PieDataSet_1: [],                  //饼状图订单地区分类
        PieDataSet_2: [],                  //饼状图订单类型分类，仅采购商和合计数据时展示
        PieDataSet_3: [],                  //饼状图用户地区分类
        disDataSet: [],                    //用户地区分类的市级数据
        currentData:{},                    //当天数据的信息
        startMonth:'',                     //查询数据的开始月份
        endMonth:'',                       //查询数据的结束月份
      }
    },
    computed: {
      ...mapState(['userLoginMessage']),
      showDetailFlag() {
        return this.$GFUN.isInArray(['2', '3', '5', '0'], this.showDetail)
      },
      chartTitle() {
        switch (this.showDetail) {
          case '2':return '采购商统计数据';
          case '3':return '酒店统计数据';
          case '5':return '民宿统计数据';
          case '0':return '统计数据合计';
        }
      },
      //按月份开始查询-开始月的第一天的0点
      startdate() {
        /*获取开始月的第一天*/
        if (this.startMonth) {
          let year = this.startMonth.split('-')[0];
          let month = this.startMonth.split('-')[1];
          let firstDay = new Date(year, month - 1, 1).getTime() / 1000;
          return Number(firstDay);
        } else return ''
      },
      //按月份开始查询-结束月的最后一天的23:59:59
      enddate() {
        /*获取结束月的最后一天*/
        if (this.endMonth) {
          let year = this.endMonth.split('-')[0];
          let month = this.endMonth.split('-')[1];
          let lastDay = new Date(year, month, 0).getTime() / 1000 + 86399;
          return Number(lastDay);
        } else return ''
      },
      //是否选择了开始月和结束月
      valuedMonth() {
        if (this.startdate && this.enddate) return this.startdate + this.enddate;
        return 0
      }
    },
    watch:{
      valuedMonth(newVal) {
        if (newVal) {
          if (this.enddate - this.startdate > 0) this.getAllDatas();
          else this._alert('结束月份应晚于开始月份', () => {
            this.startMonth = '';
            this.endMonth = '';
          },'warning');
        } else {
          this.startMonth = '';
          this.endMonth = '';
        }
      }
    },
    components: {EMap, EBar, EPie, ELine},
    created() {
      this.getAllDatas();
      this.getCurrentData();
    },
    methods: {
      /*获取页面所有的统计数据*/
      getAllDatas() {
        this.getRegNum();
        if (this.showDetail) this.showDataDetail();
        this.groupData.forEach(async item => {
          //根据身份获取对应的数据
          let resData = await this.getWrapData(item.type);
          item.childData.forEach(childItem => {
            if (childItem.key === 'total_pay_price') childItem.value = (resData[childItem.key] / 100).toFixed(2);
            else childItem.value = resData[childItem.key];
          })
        })
      },
      /*获取当天活跃数据*/
      async getCurrentData() {
        let res = await this.$axios.post('/pc/Admin/getDateReportForm',{});
        if (res.code === '00000') this.currentData = res.info;
      },
      /*获取各省份认证数*/
      async getRegNum() {
        let res = await this.$axios.post('/pc/Admin/MapVerifyTotal',{
          start_time:this.startdate,
          end_time:this.enddate
        });
        if (res.code === '00000') this.mapDataSet = res.info;
      },
      /*获取外层的数据*/
      async getWrapData(type) {
        let res = await this.$axios.post('/pc/Admin/DataTotal',{
          type,
          start_time:this.startdate,
          end_time:this.enddate
        });
        if (res.code === '00000') return res.info;
      },
      /*查看某一项的详细数据*/
      async showDataDetail(type) {
        if (type === this.showDetail) this.showDetail = '';
        else {
          type ? this.showDetail = type : '';       //当传入type值时改变当前showDetail,否则不做任何操作
          let loading = this.$loading({
            text: '数据加载中，请稍后.....',
            background: 'rgba(0, 0, 0, 0.8)',
            target: document.querySelector('.bar-wrap')
          });
          let res = await this.$axios.post('/pc/Admin/DataTotalYear',{
            type:this.showDetail,
            start_time:this.startdate,
            end_time:this.enddate
          });
          loading.close();
          if (res.code === '00000') this.formatData(type, res);
        }
      },
      /*整理后台获取的数据集合*/
      formatData(type, dataSet) {
        /*横轴的年份*/
        this.BarxAxisSet = dataSet.date_info.map(item => item.date);
        this.BarDataSet_1 = [
          {
            name: (type === '2' || type === '0' ? '发布' : '参与') + '订单总数',
            type: 'bar',
            data: dataSet.date_info.map(item => {
              return item.send_order_nos
            }),
          },
          {
            name: '成交订单总数',
            type: 'bar',
            data: dataSet.date_info.map(item => {
              return item.success_order_nos
            }),
          },
          {
            name: '支付订单总数',
            type: 'bar',
            data: dataSet.date_info.map(item => {
              return item.pay_order_nos
            }),
          }];
        this.BarDataSet_2 = [
          {
            name: '认证数',
            type: 'bar',
            data: dataSet.date_info.map(item => {
              return item.reg_nums
            }),
          },
          {
            name: '认证数',
            type: 'bar',
            data: dataSet.date_info.map(item => {
              return item.verify_nums
            }),
          },
          {
            name: '活跃数',
            type: 'bar',
            data: dataSet.date_info.map(item => {
              return item.active_nums
            }),
          }];
        this.PieDataSet_1 = dataSet.order_city_info.map(item => {
          return {value: item.count_nums, name: item.city_name}
        });

        this.PieDataSet_2 = dataSet.order_style_info.map(item => {
          return {value: item.count_nums, name: `${this.$options.filters['formatVar'](item.order_style,'StoreType')}订单`}
        });
        this.PieDataSet_3 = dataSet.user_city_info.map(item => {
          return {value: item.total_count_uses, name: item.city_name, provinceId: item.province}
        });
        this.LineDataSet = [
          {
            name: '发布订单金额',
            type: 'line',
            data: dataSet.date_info.map(item => {
              return item.send_order_price.toFixed(2)
            }),
          },
          {
            name: '成交订单金额',
            type: 'line',
            data: dataSet.date_info.map(item => {
              return item.success_order_price.toFixed(2)
            }),
          },
          {
            name: '支付金额',
            type: 'line',
            data: dataSet.date_info.map(item => {
              return (item.pay_order_price / 100).toFixed(2)
            }),
          },
        ]
      },
      /*获取用户地区分类的城市信息*/
      async getUserDis(params) {
        $('.city-item-wrap').css({
          height: $('html,body').height() * 0.3 + 'px',
        });
        let res = await this.$axios.post('/pc/Admin/getUserCityList',{
          province: params.data.provinceId,
          store_type: this.showDetail
        })
        if (res.code === '00000') {
          this.disDataSet = res.info.map(item => {
            return {
              title: item.city_name,
              value: item.total_count_uses,
              proportion: item.proportion
            }
          })
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .echart-wrap {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #0f002b;
    color: #919191;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: stretch;
    flex-direction: column;
    padding: 1rem 1.5rem 1.5rem 1.5rem;
    .e-data {
      position: relative;
      text-align: left;
      height: calc(70vh);
      width: calc(95vh);
      margin: auto;
      .travel-data, .hotel-data, .homestay-data, .total-data {
        position: absolute;
        width: 260px;
      }
      .travel-data {
        left: -45%;
        top: 0;
      }
      .hotel-data {
        right: -38%;
        top: 0;
      }
      .homestay-data {
        left: -45%;
        bottom: 0;
      }
      .total-data {
        right: -38%;
        bottom: 0;
      }
      .bar-wrap {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 20px;
        .city-list {
          position: absolute;
          right: 30px;
          top: 50px;
          width: 15%;
          color: #fff;
        }
      }
    }
  }
</style>
